mod.modules.define("RecentlySearched", "BaseModule", function(fn) {

	fn.prototype.init = function(params) {
		this.base("init", params);
	};

	fn.prototype.observables = {
		"symbol - changed": function(context) {
			this.reloadQueue({
				Symbol: context.symbol,
				ListId: context.listId
			});
		}
	};

});